export default {
      id: "route-usage",
      viewBox: "0 0 51 45",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#route",
      toString: function () {
        return this.url;
      }
    }